import ArticlePage from '../components/ArticlePage';

export default function ArticleDetail() {
  return <ArticlePage articleKey="articleDetail" />;
}
